import React from "react";
import { useSelector } from "react-redux";
import "../common.css";

function Label({ label, className = "mt-4" }) {
  const { inputLabelColor } = useSelector((state) => state.theme);
  return (
    <div className={className}>
      <div className="custom-input-title" style={{ color: inputLabelColor }}>
        {label}
      </div>
    </div>
  );
}

export default Label;
